import "./WhyChooseUs.css";
import {
  FaGem,
  FaLifeRing,
  FaArrowRight,
} from "react-icons/fa";

export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" className="why-section">
      <div className="container">

        <div className="row align-items-center gy-5">

          {/* LEFT SIDE */}
          <div className="col-lg-5">

            <div className="why-content">

              <div className="section-tag">
                <span></span>
                WHY CHOOSE US
              </div>

              <h2>
                Crafting experiences,
                <br />
                <span style={{'color' : '#08469a'}}>delivering success.</span>
              </h2>

              <p className="intro-text">
                Our commitment to quality and excellence is
                unparalleled. From the first brainstorming
                session to the final product delivery, we ensure
                perfection in every step.
              </p>

              <div className="feature-item">
                <div className="feature-icon" style={{background : '#f36b08'}}>
                  <FaGem />
                </div>

                <div className="feature-text">
                  <h4>Quality Assurance</h4>
                  <p>
                    Every deliverable meets the highest standards
                    through strict quality control and testing.
                  </p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon" style={{background : '#08469a'}}>
                  <FaLifeRing />
                </div>

                <div className="feature-text">
                  <h4>Professional Support</h4>
                  <p>
                    24/7 support ensures smooth operation and fast
                    issue resolution whenever needed.
                  </p>
                </div>
              </div>

              <a href="/" className="more-btn">
                MORE ABOUT US <FaArrowRight />
              </a>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-7">

            <div className="image-wrapper">

              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1400"
                alt="Team"
              />

              <div className="clients-box">
                <h3>200+</h3>
                <span>HAPPY CLIENTS</span>
              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}